// extracted by mini-css-extract-plugin
export default {"modalBody":"delete-status-modal_modalBody__JTGjk","applyButton":"delete-status-modal_applyButton__E9XSf"};